import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    gap: '16px',
    width: '100%',
  },
  links: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    gap: '12px',
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    height: '32px',
    px: '12px',
    borderRadius: '8px',
    borderWidth: '1px',
    borderStyle: 'solid',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    transition: 'opacity 0.2s ease',
    '&:hover': {
      opacity: 0.85,
    },
  },
  icon: {
    width: '16px',
    height: '16px',
    flexShrink: 0,
    overflow: 'visible',
  },
})

export type StylesClassNames = StylesClasses<typeof styles>
export default styles
